import { generateUsername } from 'unique-username-generator';
import humanNames from 'human-names';

export function femaleNameRandom() {
  const first = humanNames.femaleRandom();
  const last = generateUsername('', 0, 7);
  return `${first} ${last}`;
}

